<ion-header class="ion-no-border" mode="ios">
    <ion-toolbar>
        <ion-button slot="start" fill="clear" color="dark" (click)="close()">
            <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
        <ion-title>Add Branch</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>

    <div class="p-4 flex justify-center">
        <img class="w-40" src="assets/imgs/add-branch-help.png">
    </div>


    <div class="p-4 flex flex-col gap-4">

        <div class="p-4 bg-white rounded-2xl flex flex-col">
            <p class="mb-0 mt-5 ms-2 font-medium text-lg text-gray-600">Create new business account</p>
            <super-input [(value)]="orgName" class="mb-4" type="text" placeholder="Enter Business name"
                iconStart="briefcase-outline" />
            <super-button [action]="createOrganisation" iconEnd="chevron-forward-outline">Create account</super-button>
        </div>

        @if (isLoading || (organisationsThatCanBeAdded && organisationsThatCanBeAdded.length > 0)) {
        <div class="flex items-center justify-center gap-2">
            <div class="w-full h-0.5 bg-gray-200"></div>
            <p class="text-gray-600 text-sm">or</p>
            <div class="w-full h-0.5 bg-gray-200"></div>
        </div>

        <div class="p-4 bg-white rounded-2xl flex flex-col gap-2">
            @if (isLoading) {
            <p class="mb-2 mt-5 ms-2 font-medium text-lg text-gray-600">Choose an existing business account</p>
            <div class="flex items-center justify-center p-2 gap-1 flex-col">
                <ion-skeleton-text class="w-full rounded-xl h-10" [animated]="true"></ion-skeleton-text>
                <ion-skeleton-text class="w-full rounded-xl h-10" [animated]="true"></ion-skeleton-text>
                <ion-skeleton-text class="w-full rounded-xl h-10" [animated]="true"></ion-skeleton-text>
            </div>
            }
            @if (organisationsThatCanBeAdded && organisationsThatCanBeAdded.length > 0) {
            <p class="mb-2 mt-5 ms-2 font-medium text-lg text-gray-600">Choose an existing business account</p>
            <div *ngFor="let org of organisationsThatCanBeAdded; index as i"
                class="flex items-center gap-2 p-2  border-b border-gray-200">
                <avatar-round [imageUrl]="org.displayPictureUrl" [size]="30" sxWidth="30px" slot="start"></avatar-round>
                <p class="flex-1">{{org.name}}</p>
                <super-button size="v-small" type="outline" iconStart="add-outline"
                    [action]="getSetParentOrganisationAction(org._id, i)">Add</super-button>
            </div>
            }
        </div>
        }
    </div>

</ion-content>